/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExpenseBatchStatus = {
    Created: 'CREATED',
    QuoteCreated: 'QUOTE_CREATED',
    Approved: 'APPROVED',
    Invoiced: 'INVOICED',
    Paid: 'PAID',
    Cancelled: 'CANCELLED'
} as const;
export type ExpenseBatchStatus = typeof ExpenseBatchStatus[keyof typeof ExpenseBatchStatus];


export function instanceOfExpenseBatchStatus(value: any): boolean {
    for (const key in ExpenseBatchStatus) {
        if (Object.prototype.hasOwnProperty.call(ExpenseBatchStatus, key)) {
            // @ts-ignore
            if (ExpenseBatchStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ExpenseBatchStatusFromJSON(json: any): ExpenseBatchStatus {
    return ExpenseBatchStatusFromJSONTyped(json, false);
}

export function ExpenseBatchStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseBatchStatus {
    return json as ExpenseBatchStatus;
}

export function ExpenseBatchStatusToJSON(value?: ExpenseBatchStatus | null): any {
    return value as any;
}

